import React from 'react';

/**
 * Text input component with label
 * Design: High-contrast borders, monospace font
 */
export default function Input({
  label,
  id,
  type = 'text',
  placeholder,
  value,
  onChange,
  error,
  disabled = false,
  required = false,
  className = '',
  ...props
}) {
  const inputId = id || label?.toLowerCase().replace(/\s+/g, '-');

  return (
    <div className={`w-full ${className}`}>
      {label && (
        <label
          htmlFor={inputId}
          className="block font-mono text-sm font-semibold uppercase tracking-wider mb-2 text-black"
        >
          {label}
          {required && <span className="text-red-600 ml-1">*</span>}
        </label>
      )}
      <input
        id={inputId}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
        required={required}
        className={`
          w-full px-4 py-3
          border-2 border-black
          bg-white text-black
          font-mono text-sm
          placeholder:text-gray-400
          focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2
          disabled:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50
          ${error ? 'border-red-600 focus:ring-red-600' : ''}
        `}
        {...props}
      />
      {error && (
        <p className="mt-2 font-mono text-xs text-red-600 uppercase tracking-wider">
          {error}
        </p>
      )}
    </div>
  );
}
